import { h } from 'preact';

const Check = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="img" {...props}>
			<path d="M5.59937809,11.790571 L3.19856553,9.26329035 C2.93354482,8.98396283 2.93354482,8.5313056 3.19856553,8.25264473 C3.46358623,7.97331722 3.89361983,7.97331722 4.15864053,8.25264473 L6.07941559,10.2759359 L11.8404907,4.20939564 C12.1061364,3.93006812 12.53617,3.93006812 12.8005657,4.20939564 C13.0662114,4.48872315 13.0662114,4.94271369 12.8005657,5.22137455 L6.5594531,11.790571 C6.42694275,11.9299015 6.25317917,11.9999 6.07941559,11.9999 C5.90565202,11.9999 5.73188844,11.9299015 5.59937809,11.790571" />
		</svg>
	);
};

export default Check;
